<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
   

        <material-card
          title="Shipment Detail"
          text="EMN Logitic"
          color="primary">

         
          <v-form
            class="mt-4"
            ref="form"
            lazy-validation
            v-model="validForm"
            autocomplete="off"
            role="presentation">
            <v-container grid-list-md>
              <slot name="prebody"></slot>
              <v-layout wrap>

                <v-flex xs6 sm6 md6>
                     <v-text-field
                      label="Status"
                      readonly
                      v-model="shipment.status"
                      disabled
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md6 text-right>

                  <v-btn
                    v-if="$can('upsert', config.entityName) && shipment.status == 'Confirmed' && isEMN"
                    :disabled="!checkSave() && !validForm || loading || !checkPickupDate"
                    class="mx-1 white--text"
                    color="primary"
                    :loading='loading'
                    @click="shipped()">  Shipped</v-btn>

                  <v-btn
                    v-if="$can('upsert', config.entityName) && shipment.status == 'Shipped' && isEMN"
                    :disabled="!checkSave() && !validForm || loading"
                    class="mx-1 white--text"
                    color="primary"
                    :loading='loading'
                    @click="delivered()">  Delivered</v-btn>

                  <v-btn
                    v-if="$can('upsert', config.entityName) && shipment.status == 'Delivered' && (isEMN || isAttentionOf)"
                    :disabled="!checkSave() && !validForm || loading"
                    class="mx-1 white--text"
                    color="primary"
                    :loading='loading'
                    @click="received()">  Received</v-btn>

                </v-flex>



                <v-flex xs12 sm6 md6 v-if="shipment.status=='Confirmed'">
                    <v-textarea
                      label="Pickup note"
                      v-model="shipment.pickup_note"
                      rows=2
                    ></v-textarea>
                </v-flex>

                <v-flex xs12 sm6 md6 v-if="shipment.status=='Shipped' || shipment.status=='Delivered' || shipment.status=='Received'">
                  <v-tooltip top max-width="500" :disabled="!(shipment.status=='Delivered' || shipment.status=='Received') || !shipment.delivery_note">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-textarea
                          label="Delivered note"
                          v-model="shipment.delivery_note"
                          rows=2
                          :disabled="shipment.status=='Delivered' || shipment.status=='Received'"
                        ></v-textarea>
                      </div>
                    </template>
                    <span class="note-tooltip">{{ shipment.delivery_note }}</span>
                  </v-tooltip>
                </v-flex>


                <v-flex xs12 sm3 md3>

                    <div v-if="shipment.heading">
                      To Attention of : <br>
                      <a>{{shipment.heading}}</a>
                    </div>

                    <div v-if="!shipment.heading">
                      To Attention of : <br>
                      <a>{{shipment.operator.name}} {{shipment.operator.surname}}</a>
                    </div>

                </v-flex>

                 <v-flex xs12 sm6 md6>
                    Pickup : <br>
                    {{shipment.pickup.name}} <br>
                    <i><a target="_new" :href="'https://waze.com/ul?navigate=yes&q=' + shipment.pickup.address + ',' + shipment.pickup.city">{{shipment.pickup.address}} - {{shipment.pickup.cap}} - {{shipment.pickup.city}} ({{shipment.pickup.prov}})</a></i> <br>
                    {{shipment.pickup.ref_name}} {{shipment.pickup.ref_surname}}  - {{shipment.pickup.ref_tel}}<br>
                    <hr>
                </v-flex>

                <v-flex xs12 sm6 md6>
                    Delivery:<br>
                    {{shipment.delivery.name}}<br>
                    <i><a target="_new" :href="'https://waze.com/ul?navigate=yes&q=' + shipment.delivery.address + ',' + shipment.delivery.city">{{shipment.delivery.address}} - {{shipment.delivery.cap}} - {{shipment.delivery.city}} ({{shipment.delivery.prov}})</a></i><br>
                    {{shipment.delivery.ref_name}} {{shipment.delivery.ref_surname}}  - {{shipment.delivery.ref_tel}}
                    <br>
                    <hr>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <br>
                   Pickup Date: <b>{{shipment.pickup_date}}</b>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                     <app-time-range-picker
                        inputLabel= "Pickup Time Interval"
                        v-model="shipment.pickup_hour"
                        full-width
                        :outerIcon="null"
                        disabled
                        step="30"
                      />
                </v-flex>


                <v-flex xs12 sm12 md12 text-right>
                    <v-data-table hide-default-footer v-if="!isNew" style="width:100%"
                      :items="packs"
                      :headers="[
                        { text: 'n.Packages', value: 'pack', sortable: false },
                        { text: 'Content', value: 'content', sortable: false },
                        { text: 'Dimension', value: 'dimension', sortable: false },
                        { text: 'Kg', value: 'weight', sortable: false },
                        { text: 'Note', value: 'note', sortable: false },
                        ]">


                      <template slot="header" slot-scope="props" >
                        <tr>
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="[
                              'column',
                              header.align ?'text-xs-' + header.align : 'text-xs-left',
                            ]"
                          >
                            <v-icon v-if="header.sortable != false" small
                              >mdi-menu-down</v-icon
                            >
                            <span
                              class="subheading font-weight-dark text-success text-darken-3"
                              v-text="header.text"
                            ></span>
                          </th>
                        </tr>
                    </template>

                  </v-data-table>
                </v-flex>


                <v-flex xs12 sm12 md12 text-right>
                </v-flex>

                <v-flex xs12 sm12 md12 text-right>
                </v-flex>

                <v-flex xs12 sm12 md12 text-right>
                </v-flex>
               

               
              </v-layout>
            </v-container>
          </v-form>

        </material-card>
      
    </v-flex>

  </v-container>
</template>

<script>
import { getDetail, getList, put } from '@/api/base_entity'
import config from './config_upsert.js'
import validators from '../../utils/validators.js'

export default {
  inheritAttrs: false,
  data () {
    return {
      validForm:true,
      validators,
      config,
      loading: false,
      shipment: {operator:{}, pickup_id: null, delivery_id:null, pickup_hour:{start:'', end:''}, pickup:{}, delivery:{}},
      newPack: {},
      packs: [],
      isEditPack: false,
      address:''
    }
  },
  async created () {
    if (this.$route.params.id) {
      this.getData()
    }
  },
  async mounted () {
  
  },
  computed: {
    isNew() {
      return this.shipment.id ? false : true
    },
    isEMN() {
      return this.shipment.carrier == 'EMN Logistic'
    },
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
    isAttentionOf() {
      if(!this.shipment.operator)
        return
      return this.$store.getters.user.account_id == this.shipment.operator.id
    },
    checkPickupDate()
    {
      const dObj = new Date(this.shipment.pickup_date)
      const today = new Date();
      if(today >= dObj) {
        return true
      }
      return false
    }
  },
  methods: {
    async getData() {
      this.shipment = await getDetail('shipment', this.$route.params.id)

      if(!this.shipment.operator) {
        this.shipment.operator = {}
      }

      if(!this.shipment.pickup_hour) {
        this.shipment.pickup_hour = {}
      }
      this.loadPacks()
    },
    checkSave () {
      return !this.isNew
    },
    async loadPacks() {
      const packs = await getList('pack', { shipment_id: this.shipment.id }, {}, {rowsPerPage: -1})
      this.packs = packs['data']
    },
    shipped() {
        
      put('shipment/shipped', this.shipment.id, this.shipment).then( (ret) => {
         this.$root.$emit('openSnackbar', {
            message:'Shipment updated correctly : SHIPPED',
            color: 'success'
          })
          this.shipment = ret.data
      })
    },
    delivered() {
        
      put('shipment/delivered', this.shipment.id, this.shipment).then( (ret) => {
         this.$root.$emit('openSnackbar', {
            message: 'Shipment updated correctly : DELIVERED',
            color: 'success'
          })
          this.shipment = ret.data
      })
    },

    received() {
      put('shipment/received', this.shipment.id, this.shipment).then( (ret) => {
         this.$root.$emit('openSnackbar', {
            message: 'Shipment updated correctly : RECEIVED',
            color: 'success'
          })
          this.shipment = ret.data
      })
    },
    
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
